import React, { useEffect, useState } from 'react';
import { checkValidity } from '../../shared/utility';
import Input from '../../UI/Input/Input';

const UserNameBlock = (props) => {

    const [formInputElements, setFormInputElements] = useState({
        username:{
            elementType: 'input',
            elementConfig: {
                type: 'text',
                id: 'username',
                placeholder: '',
            },
            value: props.userNameValue,
            validation: {
                required: false,
                minlength: 2
            },
            valid: true,
            touched: false,
            label: "User Name",
            inputType: "Half"
        },
    })

    const createUUIDForm = () => {
        return {
            elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'uuid',
                    placeholder: '',
                    maxLength: 101
                },
                value: props.uuidValue,
                validation: {
                    required: false,
                    minlength: 2,
                    maxlength: 100,
                    nospace: true,
                },
                valid: true,
                touched: false,
                label: "UUID",
                inputType: "Half",
                disabled: false
        }
    }

    const setFormInitial = () => {
        const updatedForm = {...formInputElements}
        if(props.eventType === 'USER' || props.eventType === 'ALL'){
            updatedForm['uuid'] = createUUIDForm()
            setFormInputElements(updatedForm)
        }else{
            delete updatedForm['uuid']
            setFormInputElements(updatedForm)
        }
    }

    useEffect(() => {
        props.clearSearch.current = clearUserName
        setFormInitial()
    },[props.eventType])

    const clearUserName = () => {
        const updatedForm = {...formInputElements}

        updatedForm['username'].value = ''
        updatedForm['username'].touched = false
        updatedForm['username'].valid = true

        if(props.eventType === 'USER' || props.eventType === 'ALL'){
            updatedForm['uuid'] = createUUIDForm()
            updatedForm['uuid'].value = ''
            updatedForm['uuid'].touched = false
            updatedForm['uuid'].valid = true
        }else{
            delete updatedForm['uuid']
        }

        setFormInputElements(updatedForm)
        props.setFormIsValid(true)
    }

    const inputChangedHandler = (eventReceived, formIdentifier) => {
    
        let updatedForm = {...formInputElements};

        const updatedFormElement = { ...updatedForm[formIdentifier] };
        updatedFormElement.value = eventReceived.target.value;

        if(eventReceived.target.value) {
            const validation = checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.valid = validation.isValid;
            props.errorHandler({message: validation.message});
        } else {
            updatedFormElement.valid = true;
            props.errorHandler(null);
        }
        updatedFormElement.touched = true;
        updatedForm[formIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        if(formIdentifier === 'username'){
            props.setUsername(eventReceived.target.value)
        }
        else{
            props.setUuid(eventReceived.target.value)
        }
        props.setFormIsValid(formIsValid);
        setFormInputElements(updatedForm);
    }

    const createForm = () => {

        const formsElementsArray =[];

        for(let key in formInputElements) {
            formsElementsArray.push({
                id: key,
                config: formInputElements[key]
            });
        }

    
        return (
        <>
            <div style={{"display":"flex"}}>
                {formsElementsArray.map((formElement => (
                    <Input
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        label={formElement.config.label}
                        changed={(event) => inputChangedHandler(event, formElement.id)}
                        extendedInput={formElement.config.extendedInput}
                        inputType={formElement.config.inputType}
                    />
                )))}
            </div>
        </>
        )
        
    }

    return <>
        {createForm()}
    </>

}

export default UserNameBlock;